import { render, staticRenderFns } from "./TargetingSource.vue?vue&type=template&id=a535d8f8&"
import script from "./TargetingSource.vue?vue&type=script&lang=js&"
export * from "./TargetingSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports